const mapFeatures = {
    customBoosting: 'Custom Boosting',
    advertisements: 'Advertisements',
    languageManager: 'Language Manager',
    displayContentTabs: 'Display Content Tabs',
    facetInterpreter: 'Facet Interpreter',
    neuralSearch: 'Neural Search',
    hybridSearch: 'Hybrid Search',
    similarSearch :'Similar Search',
    previewSearchResult: 'Preview Search Results',
    autoBoosting: 'Auto Boosting',
    recommendations: 'Recommendations',
    preSelectionFacets: 'Pre Selection of facets',
    stage2Deflections: 'Show Stage 2 Deflection ( Support Page )',
    ner: 'Named-entity recognition (NER)',
    emailTracking: 'Email Tracking',
    hideAllFacets: 'Hide All Facets',
    keywordBoostedDocuments: 'Boost Document for Keywords',
    salesForceArticlesBoosting: 'Salesforce articles (Attached to cases)',
    reranking: 'Re-ranking',
    clickBoostingBase: 'Click Boosting Base',
    intentBoostedDocuments: 'Boost Document for Intent',
    limitTrackingToLoggedUsers: 'Limit tracking to logged in users',
    userAttribute: 'Track User Attribute',
    userEntitlements: 'User Entitlements',
    byPassAllFilters: 'ByPass All filters',
    contentBoosting: 'Content Boosting',
    autoSpellCorrector: 'Enable Auto Spell Corrector',
    gpt: 'SearchUnifyGPT',
    dateBoosting: 'Date Boosting',
    recentSearch: 'Recent Searches',
    internalExternalEmailTracking: 'Internal/External email tracking enabled',
    specialCharSearch: 'Special characters search',
    customizeSearchClient: 'Customize Search Client View',
    hideCSWithMinDocCount: 'Hide Content Source with Minimum Document Count',
    collapseSummary: 'Collapse Summary',
    highlightClickedResult: 'Highlight Clicked Results',
    richSnippet: 'Rich Snippets',
    mergeResult: 'Merge Results',
    didYouMean: 'Did You Mean',
    pageViews: 'Capture Direct Pageviews in Session Journey',
    mergeResults: 'Merge Results',
    byPassFiltered: 'ByPass All filters',
    knowledgeGraph: 'Knowledge Graph',
    exactMatch: 'Exact match',
    useSearchSynonyms: 'Use Search Synonyms',
    textFeedback: 'Text Feedback',
    followUpFeedback: 'Follow Up On Feedback',
    synonymKeywordBoosting: 'Apply the same Keyword Tuning on the added Synonyms/Abbreviations'
};

export {
    mapFeatures
};